export default {
  identityInformation: {
    title: "معلومات الهوية",
    rejectReason: "سبب رفض التحقق من الهوية:",
    quickVerification:
      "إذا كنت ترغب في التحقق من هويتك بشكل أسرع، نقترح استخدام التطبيق.",
    quickVerificationButton: "فهمت",
    getOTP: "احصل على رمز التحقق",
    submitButton: "متابعة",
    personalStatus: {
      verified: "تم التحقق من هويتك بالكامل",
      progress: {
        title: "لم يكتمل التحقق من هويتك",
        subtitle: "بإكمال التحقق من هويتك، يمكنك إيداع وسحب الريال.",
        steps: {
          contactInfo: "معلومات الاتصال",
          personalInfo: "المعلومات الشخصية",
          identityInfo: "التحقق من الهوية",
          internationalCardImage: "صورة بطاقة الهوية الوطنية",
          confirmKyc: "تأكيد التحقق من الهوية"
        }
      }
    },
    contactInfo: {
      headerTitle: "التحقق من معلومات الاتصال",
      title: "معلومات الاتصال",
      mobile: {
        title: "رقم الهاتف المحمول",
        verified: "تم التحقق",
        unverified: "لم يتم التحقق",
        verifyMobileButton: "التحقق من رقم الهاتف المحمول*",
        submitButton: "إرسال",
        validations: {
          emptyPassword: "أدخل كلمة المرور",
          invalidCode: "رمز SMS غير صالح",
          emptyCode: "أدخل رمز SMS"
        },
        modals: {
          getMobileNumber: {
            title: "التحقق من رقم الهاتف المحمول",
            subtitle: "أدخل رقم هاتفك المحمول",
            inputLabel: "رقم الهاتف المحمول",
            inputExample: "مثال: 09123456789",
            submitButton: "متابعة",
            mobileValidation: {
              invalid: "رقم الهاتف المحمول غير صالح"
            }
          },
          getVerificationCode: {
            title: "أدخل الرمز المرسل إلى {n}.",
            inputPlaceholder: "رمز SMS",
            getVerificationCodeAgainButton: "إعادة إرسال رمز التحقق",
            getVerificationCodeAgainTitle: "إعادة إرسال الرمز في",
            getVerificationCodeAgainSecondsTitle: "ثوانٍ",
            submitButton: "تأكيد",
            previousStep: "الخطوة السابقة"
          }
        }
      },
      phone: {
        title: "رقم الهاتف",
        verified: "تم التحقق",
        unverified: "لم يتم التحقق",
        verifyPhoneButton: "التحقق من رقم الهاتف",
        submitButton: "إرسال",
        phoneValidation: {
          invalid: "رقم الهاتف غير صالح",
          empty: "أدخل رقم الهاتف"
        },
        modals: {
          getPhoneNumber: {
            title: "التحقق من رقم الهاتف",
            subtitle: "أدخل رقم هاتفك مع رمز المدينة",
            inputLabel: "رقم الهاتف",
            submitButton: "متابعة",
            inputExample: "مثال: 02123456789"
          },
          getVerificationCode: {
            title:
              "أدخل الرمز المكون من 6 أرقام الذي سُمِعَ لك عبر مكالمة هاتفية إلى ({n}) في المربع أدناه",
            inputPlaceholder: "الرمز المستلم",
            getVerificationCodeAgainButton: "إعادة إرسال رمز التحقق",
            getVerificationCodeAgainTitle: "إعادة إرسال الرمز في",
            getVerificationCodeAgainSecondsTitle: "ثوانٍ",
            submitButton: "تأكيد",
            previousStep: "الخطوة السابقة"
          }
        }
      },
      email: {
        title: "البريد الإلكتروني",
        verified: "تم التحقق",
        unverified: "لم يتم التحقق",
        verifyEmailButton: "التحقق من البريد الإلكتروني",
        submitButton: "إرسال",
        emailValidation: {
          invalid: "البريد الإلكتروني غير صالح",
          empty: "أدخل البريد الإلكتروني"
        },
        modals: {
          getEmail: {
            title: "التحقق من عنوان البريد الإلكتروني",
            subtitle: "أدخل بريدك الإلكتروني",
            inputLabel: "البريد الإلكتروني",
            submitButton: "متابعة",
            inputExample: "مثال: user@gmail.com"
          },
          getVerificationCode: {
            title: "اضغط على 'احصل على الرمز' لتلقي رمز التحقق",
            inputPlaceholder: "رمز التحقق من البريد الإلكتروني",
            getVerificationCodeAgainButton: "احصل على الرمز",
            getVerificationCodeAgainTitle: "إعادة إرسال الرمز في",
            getVerificationCodeAgainSecondsTitle: "ثوانٍ",
            submitButton: "تأكيد",
            previousStep: "الخطوة السابقة"
          }
        }
      }
    },
    personalInformation: {
      title: "المعلومات الشخصية",
      verified: "تم التحقق",
      pending: "قيد الانتظار",
      edit: "تعديل",
      submit: "إرسال",
      fullName: "الاسم الكامل",
      nationalCode: "الرمز الوطني",
      dateOfBirth: "تاريخ الميلاد",
      authUnavailable:
        "خدمة التحقق من الهوية غير متاحة مؤقتًا. يرجى المحاولة مرة أخرى لاحقًا.",
      pictureVerify: {
        title: "صورة التحقق من الهوية",
        validation: {
          part1: "لتحميل صورة التحقق من الهوية، أولاً أكمل",
          part2: "قسم المعلومات الشخصية"
        }
      },
      modals: {
        getPersonalInfo: {
          title: "أدخل المعلومات الشخصية",
          subtitle: "أدخل معلوماتك الشخصية وفقًا لوثيقة الهوية الخاصة بك",
          firstNameLabel: "الاسم الأول",
          lastNameLabel: "اللقب",
          nationalCodeLabel: "الرمز الوطني",
          dateLabel: "تاريخ الميلاد",
          submitButton: "إرسال"
        }
      },
      validation: {
        noValid: "غير صحيح",
        firstNameRequired: "الأول مطلوب",
        firstNamePersianRequired: "أدخل اسمك الأول باللغة الفارسية",
        lastNameRequired: "اللقب مطلوب",
        lastNamePersianRequired: "أدخل لقبك باللغة الفارسية",
        birthDayRequired: "تاريخ الميلاد مطلوب",
        nationalCodeRequired: "الرمز الوطني مطلوب",
        nationalCodeValidation: "الرمز الوطني غير صحيح"
      },
      hints: {
        firstName: "الاسم الأول باللغة الفارسية وفقًا للهوية الوطنية",
        lastName: "اللقب تمامًا كما هو في الهوية الوطنية",
        nationalCode: "مثال: 0011283927"
      }
    },
    personalPicture: {
      title: "التحقق من الهوية",
      hasIdentityTitle:
        "لتحميل صورة التحقق من الهوية، أكمل كلا من قسم معلومات الاتصال وقسم المعلومات الشخصية أولاً",
      isPendingTitle:
        "قد يستغرق عملية التحقق من صورة الهوية بعض الوقت. شكرًا لصبرك.",
      verified: "تم التحقق",
      pending: "قيد الانتظار",
      submit: "إرسال",
      modals: {
        getPersonalPicture: {
          title: "صورة التحقق من الهوية",
          subtitle:
            "للتحقق من هويتك، حمل صورة كما هو موضح في العينة والبنود المطلوبة في الوصف",
          uploadButton: "تحميل",
          uploadInputFile: "تحميل صورة التحقق من الهوية",
          uploadGuideLine: "دليل تحميل صورة التحقق من الهوية",
          guideLineParagraph:
            "في الصورة المحملة، أمسك بهويتك الوطنية الذكية الأصلية مع مذكرة مكتوبة بخط اليد تحتوي على النص أدناه بجانب وجهك.",
          textTitle: "نص المذكرة",
          mainText:
            "لقد قرأت وقبلت جميع قواعد Excoino وأتحمل المسؤولية عن جميع المعاملات من الحساب. أتعهد بعدم إعطاء حساب المستخدم وبطاقة البنك الخاصة بي لشخص آخر.",
          dateAndSignature: "التاريخ والتوقيع",
          guideLineParagraph2: "اضبط إطار الصورة لتظهر بوضوح أنك تحمل الوثائق.",
          guideLineParagraph3:
            "يجب أن يكون نص المذكرة، وثيقة الهوية، وكامل الصورة واضحًا بدون أي تشويش أو تأثير.",
          guideLineParagraph4:
            "يجب أن يكون حجم الصورة بين 100 كيلوبايت و10 ميغابايت.",
          takingPictureGuideLine: "صورة العينة",
          validFormatsTitle: "تنسيقات الملفات المسموح بها:",
          invalidFormatFiles: "تنسيق الملف غير صالح.",
          minFileSizeValidation:
            "يجب أن يكون حجم الملف على الأقل 100 كيلوبايت.",
          maxFileSizeValidation: "يجب ألا يتجاوز حجم الملف 10 ميغابايت."
        }
      }
    },
    autoVerification: {
      title: "التحقق من الهوية",
      isRejectTitle:
        "لم يتم الموافقة على التحقق من هويتك. لإعادة المحاولة، يرجى استخدام التطبيق.",
      changeIdentificationMethod: "تغيير طريقة التحقق من الهوية",
      orManual1: "أو استخدم",
      orManual2: "بدلاً من ذلك.",
      manualIdentification: "التحقق من الهوية اليدوي",
      verified: "تم التحقق",
      pending: "قيد الانتظار",
      unverified: "لم يتم التحقق",
      submit: "إرسال",
      modals: {
        changeIdentificationMethod: {
          title: "تغيير طريقة التحقق من الهوية",
          subtitle:
            "هل أنت متأكد من رغبتك في التحويل إلى 'التحقق من الهوية اليدوي'؟ تأكيد ذلك سيلغي عملية 'التحقق من الهوية السريع'.",
          confirmButton: "تأكيد",
          cancelButton: "إلغاء"
        }
      }
    },
    internationalCard: {
      headerTitle: "التحقق ومراجعة الهوية الوطنية",
      headerDescription:
        "تحقق أو عدل معلومات وصورة هويتك الوطنية إذا كان هناك أي اختلاف.",
      internationalCardGuidTitle: "دليل صورة الهوية الوطنية",
      internationalCardGuidText: "يجب قراءته"
    }
  },
  bankInformation: {
    title: "معلومات البنك",
    bankCards: {
      title: "بطاقات البنك",
      addCardsButton: "إضافة بطاقة جديدة",
      empty: "لا توجد بطاقات بنك مسجلة",
      modals: {
        addCards: {
          title: "إضافة بطاقة بنكية جديدة",
          subtitle: "تأكد من أن البطاقة التي تسجلها باسمك.",
          cardLabel: "رقم البطاقة",
          invalidInputCard: "رقم البطاقة غير صحيح",
          emptyInputCard: "أدخل رقم البطاقة",
          addCardButton: "تحقق وأضف البطاقة"
        },
        deleteCard: {
          title: "حذف رقم البطاقة",
          subtitle: "هل أنت متأكد من أنك تريد حذف رقم البطاقة هذا؟",
          deleteButton: "نعم، احذفه",
          cancelButton: "إلغاء"
        }
      }
    },
    shebaCards: {
      title: "عناوين شبا",
      addCardsButton: "إضافة عنوان شبا",
      empty: "لا توجد عناوين شبا مسجلة",
      modals: {
        addCards: {
          title: "إضافة رقم شبا",
          subtitle: "تأكد من أن رقم شبا الذي تسجله باسمك.",
          titleInputLabel: "العنوان",
          shebaInputLabel: "رقم شبا",
          emptyTitleInputCard: "أدخل العنوان",
          invalidShebaInputCard: "رقم شبا غير صحيح",
          emptyShebaInputCard: "أدخل رقم شبا",
          addCardButton: "تحقق وأضف رقم شبا"
        },
        deleteCard: {
          title: "حذف رقم شبا",
          subtitle: "هل أنت متأكد من أنك تريد حذف رقم شبا هذا؟",
          deleteButton: "حذف",
          cancelButton: "إلغاء"
        }
      }
    }
  },
  security: {
    title: "أمان الحساب",
    twoFactorAuth: {
      title: "عوامل الأمان",
      subtitle:
        "لزيادة أمان أصولك (أثناء السحب، الشراء، إلخ)، نوصي بتمكين المصادقة الثنائية.",
      SMSAuthentication: {
        title: "مصادقة الرسائل القصيرة",
        defaultRadioButton: "افتراضي",
        inactiveButton: "تعطيل",
        activeButton: "تفعيل"
      },
      emailAuthentication: {
        title: "مصادقة البريد الإلكتروني",
        defaultRadioButton: "افتراضي",
        inactiveButton: "تعطيل",
        activeButton: "تفعيل"
      },
      googleAuthenticator: {
        title: "Google Authenticator",
        defaultRadioButton: "افتراضي",
        inactiveButton: "تعطيل",
        activeButton: "تفعيل"
      },
      activeAuthenticator: {
        title: "المصادقة الثنائية (2FA)",
        defaultTitle: "افتراضي",
        defaultItems: {
          sms: "بالهاتف المحمول",
          email: "بالبريد الإلكتروني",
          google2fa: "باستخدام Google Authenticator"
        },
        inactiveButton: "تعطيل",
        activeButton: "تفعيل"
      },
      loginWith2fa: {
        title: "المصادقة الثنائية (2FA)",
        subtitle:
          "لزيادة أمان أصولك (أثناء السحب، الشراء، إلخ)، نوصي بتمكين المصادقة الثنائية.",
        inactiveButton: "تعطيل",
        items: [
          {
            title: "بالهاتف المحمول",
            value: "sms"
          },
          {
            title: "بالبريد الإلكتروني",
            value: "email"
          },
          {
            title: "باستخدام Google Authenticator",
            value: "google2fa"
          }
        ],
        hints: {
          mobile:
            "لتفعيل المصادقة الثنائية باستخدام الهاتف المحمول، يرجى تسجيل والتحقق من هاتفك المحمول أولاً.",
          email:
            "لتفعيل المصادقة الثنائية باستخدام البريد الإلكتروني، يرجى تسجيل والتحقق من بريدك الإلكتروني أولاً.",
          google2fa:
            "لتفعيل المصادقة الثنائية باستخدام Google (Google Authenticator)، يرجى تمكين Google Authenticator أولاً."
        }
      },
      modals: {
        activeDetails: {
          title: "المصادقة الثنائية",
          subtitle: "اضغط على 'احصل على الرمز' لتلقي رمز التحقق",
          getCodeButton: "احصل على الرمز"
        },
        activeEmail: {
          codeLabel: "رمز التحقق من البريد الإلكتروني"
        },
        activeGoogle: {
          codeLabel: "رمز Google Authenticator",
          title: "Google Authenticator",
          stepper: [
            {
              id: 1,
              name: "تنزيل التطبيق",
              icon: "$downloadSaveUpload"
            },
            {
              id: 2,
              name: "مسح رمز الاستجابة السريعة",
              icon: "$qrCode"
            },
            {
              id: 3,
              name: "احتفظ بالرمز",
              icon: "$floppySave"
            },
            {
              id: 4,
              name: "تفعيل",
              icon: "$doneCheck"
            }
          ],
          step1: {
            title: "تنزيل وتثبيت تطبيق Google Authenticator",
            nextStepButton: "الخطوة التالية"
          },
          step2: {
            title:
              "مسح رمز الاستجابة السريعة أدناه باستخدام تطبيق Google Authenticator",
            subtitle:
              "إذا لم تتمكن من مسح رمز الاستجابة السريعة، يمكنك إدخال الرمز أدناه يدويًا في التطبيق",
            nextStepButton: "الخطوة التالية",
            previousStepButton: "الخطوة السابقة"
          },
          step3: {
            title: "تأكد من كتابة الرمز أدناه",
            subtitle:
              "في حالة فقدان أو سرقة هاتفك المحمول، يمكنك استعادة Google Authenticator باستخدام هذا الرمز",
            nextStepButton: "الخطوة التالية",
            previousStepButton: "الخطوة السابقة"
          },
          step4: {
            googleAuthCodeTitle:
              "أدخل رمز Google Authenticator المكون من 6 أرقام",
            googleAuthCodeLabel: "رمز Google Authenticator المكون من 6 أرقام",
            emptyGoogleAuth: "أدخل رمز Google Authenticator المكون من 6 أرقام",
            passwordTitle: "أدخل كلمة المرور الخاصة بك",
            passwordLabel: "كلمة المرور",
            emptyPassword: "أدخل كلمة المرور الخاصة بك",
            submitButton: "تأكيد وإنهاء",
            previousStepButton: "الخطوة السابقة"
          }
        },
        inactiveModal: {
          title: "تعطيل المصادقة الثنائية (2FA)",
          warning:
            "تعطيل المصادقة الثنائية يجعل حسابك أكثر عرضة للوصول غير المصرح به. يوصى بإعادة تمكينها في أقرب وقت ممكن.",
          passwordTitle: "أدخل كلمة المرور الخاصة بك",
          passwordLabel: "كلمة المرور",
          emptyPassword: "أدخل كلمة المرور الخاصة بك",
          submitButton: "تأكيد"
        },
        activeSMS: {
          codeLabel: "رمز التحقق من الهاتف المحمول",
          step1: {
            title: "التحقق من رقم الهاتف المحمول",
            subtitle: "أدخل رقم هاتفك المحمول",
            warning:
              "ملاحظة: سيتم اعتبار رقم الهاتف الذي تدخله رقم هاتفك الرئيسي ولا يمكن تحريره.",
            mobileLabel: "رقم الهاتف المحمول",
            mobileHint: "مثال: 09123456789",
            nextStepButton: "متابعة"
          },
          step2: {
            title: "تفعيل مصادقة الرسائل القصيرة",
            subtitle: "يرجى إدخال الرمز المرسل إلى ({n}).",
            codeLabel: "رمز SMS",
            resendCodeButton: "إعادة إرسال رمز التحقق",
            counterTitle: {
              part1: "إعادة إرسال الرمز في",
              part2: "ثوانٍ"
            },
            passwordTitle: "أدخل كلمة المرور الخاصة بك",
            passwordLabel: "كلمة المرور",
            submitButton: "تأكيد",
            previousStepButton: "الخطوة السابقة"
          }
        },
        inactiveSMS: {
          title: "تعطيل مصادقة الرسائل القصيرة",
          warning:
            "تعطيل المصادقة الثنائية يجعل حسابك أكثر عرضة للوصول غير المصرح به. يوصى بإعادة تمكينها في أقرب وقت ممكن. بعد التعطيل، إذا تم الكشف عن نشاط غير عادي، قد لا تتمكن من سحب الريال والعملات المشفرة لمدة 24 ساعة.",
          passwordTitle: "أدخل كلمة المرور لتعطيل مصادقة الرسائل القصيرة",
          passwordLabel: "كلمة المرور",
          emptyPassword: "أدخل كلمة المرور الخاصة بك",
          submitButton: "تأكيد"
        }
      }
    },
    username: {
      title: "اسم المستخدم",
      submitButton: "إرسال",
      modals: {
        addUsername: {
          title: "إضافة اسم المستخدم",
          warning:
            "ملاحظة: لا يمكن تغيير اسم المستخدم الذي تختاره. يرجى اختيار بعناية.",
          usernameLabel: "اسم المستخدم",
          usernameHints: {
            title: "يجب أن يكون اسم المستخدم:",
            item1: "بين 4 و32 حرفًا.",
            item2: "يحتوي فقط على أحرف إنجليزية"
          },
          submitButton: "تأكيد"
        }
      }
    },
    password: {
      title: "كلمة المرور",
      changeButton: "تعديل",
      modals: {
        changePassword: {
          title: "تعديل كلمة المرور",
          currentPasswordLabel: "كلمة المرور الحالية",
          emptyPassword: "أدخل كلمة المرور الحالية",
          newPasswordLabel: "كلمة المرور الجديدة",
          emptyNewPassword: "أدخل كلمة المرور الجديدة",
          passwordHint: "يجب أن تكون كلمة المرور:",
          confirmNewPasswordLabel: "تأكيد كلمة المرور الجديدة",
          emptyConfirmNewPassword: "أدخل تأكيد كلمة المرور الجديدة",
          submitButton: "تأكيد"
        }
      }
    },
    securityTwoFactorAuth: {
      watchVideoText: "شاهد فيديو الإرشادات",
      closeBtn: "إغلاق",
      watchGoogleGuid: "شاهد دليل تفعيل Google Authenticator الكامل"
    }
  },
  accountSidebar: {
    unverified: "غير مؤكد",
    completeVerification: "أكمل التحقق",
    totalAssets: "قيمة الأصول الإجمالية",
    profitLoss: "إجمالي الربح (الخسارة)",
    links: {
      identity: {
        title: "معلومات الهوية",
        label: "أكمل التحقق",
        description: "أكمل، اعرض، وعدل معلومات الهوية"
      },
      bankInformation: {
        title: "معلومات البنك",
        label: "",
        description: "إدارة أرقام شبا وبطاقات البنك"
      },
      security: {
        title: "الأمان",
        label: "",
        description: "إدارة كلمة المرور، المصادقة الثنائية، اسم المستخدم"
      }
    },
    signOutButton: "تسجيل الخروج",
    referralCard: {
      introduceToFriends: "ادعو أصدقائك",
      inviteGetExcoin: "ادع أصدقائك، واحصل على Excoin",
      referralCode: "رمز الإحالة",
      referralCodeCopied: "تم نسخ رمز الإحالة"
    }
  },
  level: {
    title: "مستويات المستخدم",
    accountLevelText: "أنت مستخدم بمستوى {level}",
    enterToLevelBtn: "أدخل هذا المستوى",
    unlimitedText: "غير محدود",
    descriptionText: "الوصف"
  },
  kyc: {
    checkText: "تتم مراجعة معلوماتك",
    checkText2:
      "بعد مراجعة المعلومات والموافقة عليها، سيتم إكمال التحقق من هويتك وإخطارك عبر SMS",
    autoKyc: {
      internationalCard: {
        guidTitle: "دليل صورة الهوية الوطنية",
        originalImageText: "التقط صورة لهويتك الوطنية الأصلية.",
        bgImageText:
          "يجب أن تكون الخلفية التي توضع عليها الهوية الوطنية بلون واحد.",
        clearImageText: "يجب أن تكون الصورة واضحة ويمكن التعرف عليها.",
        blackAndWhiteImageText: "يجب ألا تكون الصورة بالأبيض والأسود.",
        notValidImageText:
          "يجب ألا تكون الهوية الوطنية قديمة أو منتهية الصلاحية.",
        receiveInformationText: "نقوم بجمع معلوماتك",
        delayText: "قد يستغرق الأمر بضع ثوانٍ",
        uploadCard: {
          onTheCardTitle: "اختر الجانب الأمامي من صورة الهوية الوطنية",
          backTheCardTitle: "اختر الجانب الخلفي من صورة الهوية الوطنية"
        }
      },
      kycTypeSelection: {
        fillText: "يرجى إكمال التحقق من هويتك",
        accessToCompleteText:
          "لإكمال التحقق من هويتك، تحتاج إلى الوصول إلى هويتك الوطنية الذكية.",
        fastRecognize: "التحقق من الهوية السريع",
        recognizeIn10Sec: "التحقق من الهوية في 10 دقائق",
        inFastRecognize: "في التحقق من",
        recordVideoText: "تحتاج إلى تسجيل فيديو لنفسك.",
        autoProccessText: "عملية المراجعة آلية.",
        startFastRecongnize: "بدء التحقق من",
        normalRecognize: "التحقق من الهوية اليدوي",
        recognizeIn10Min: "التحقق من الهوية في ساعتين",
        inNormalRecognize: "في التحقق من الهوية اليدوي",
        uploadImageText: "تحتاج إلى التقاط أو تحميل صورة لنفسك.",
        supportCheckProsseccText: "تتم عملية المراجعة من قبل فريق الدعم.",
        startNormalRecongnize: "بدء التحقق من الهوية اليدوي",
        confidentionalInfoText:
          "يتم استخدام المعلومات التي تقدمها أثناء التحقق من الهوية فقط لأغراض التعريف وتبقى سرية من قبل Excoino."
      },
      videoGuid: {
        recognizeVideoTitle: "فيديو التحقق من الهوية",
        toStartRecording:
          "للبدء، انظر إلى الكاميرا واتبع التعليمات على الشاشة.",
        importantPoints: "نقاط مهمة",
        islamicPrinciplesText: "احترم المبادئ الإسلامية.",
        fullFaceText: "تأكد من ظهور وجهك بالكامل في الإطار.",
        checkMicText: "تحقق من الإضاءة والميكروفون.",
        readText: "اقرأ النص المعروض بوضوح وبصوت عالٍ.",
        avoidHatText: "لا ترتدي قبعة.",
        avoidEffectText: "لا تستخدم أي تأثيرات على الفيديو.",
        clickRecordAndRead:
          "اضغط على زر تسجيل الفيديو واقرأ النص أدناه بوضوح وبصوت عالٍ:",
        acceptTerms:
          "للتحقق من الهوية على Excoino، قرأت القواعد وأقبل المسؤولية عن جميع المعاملات من حسابي. لا أعطي حساب المستخدم وبطاقة البنك الخاصة بي لشخص آخر.",
        watchVideo: "عرض الفيديو المسجل",
        recordVideoTitle: "تسجيل فيديو",
        stopVideoTitle: "إيقاف",
        recordAgainText: "تسجيل الفيديو مرة أخرى",
        acceptAndContinue: "تأكيد ومتابعة",
        gettingDataText: "نقوم بجمع بياناتك",
        delayText: "قد يستغرق الأمر بضع ثوانٍ"
      }
    },
    manualKyc: {
      imageSelectionTitle: "اختر صورة التحقق من الهوية",
      takePhotoTitle: "التقط صورة التحقق من الهوية بالكاميرا",
      takePhoto: {
        acceptPreviousConditionsText:
          "اتبع الشروط المذكورة في القسم السابق واضغط على زر التقاط الصورة.",
        checkTakenPhotoText:
          "راجع الصورة الملتقطة وإذا كانت تفي بالشروط، اضغط على زر التأكيد والمتابعة.",
        blockedUsingCameraText: "لقد قمت بحجب الوصول إلى الكاميرا",
        activeUsingCameraText:
          "إذا رغبت، يمكنك تمكين الوصول إلى الكاميرا من إعدادات المتصفح",
        takePhotoTitle: "التقاط صورة",
        takePhotoAgainBtn: "التقاط الصورة مرة أخرى",
        acceptAndContinue: "تأكيد ومتابعة"
      }
    },
    noWebcam: {
      doNotHaveWebcamText: "جهازي لا يحتوي على كاميرا ويب",
      continueIfDoNotHaveWebcamText:
        "إذا لم يكن لديك إمكانية الوصول إلى كاميرا ويب، يمكنك متابعة عملية التحقق من الهوية على تطبيق Excoino",
      fastRecognizeTitle: "التحقق من الهوية السريع",
      useExcoinoToRecognize:
        "لمتابعة عملية التحقق من الهوية، يمكنك استخدام تطبيق Excoino",
      scanToDownoalBtn: "مسح لتنزيل",
      normalRecognizeTitle: "التحقق من الهوية اليدوي",
      inNormalRecognizeText: "في التحقق من الهوية اليدوي",
      uploadPhotoText: "تحتاج إلى تحميل صورة لنفسك.",
      checkBySupportText: "تتم عملية المراجعة من قبل فريق الدعم.",
      startNormalRecognizeBtn: "بدء التحقق من الهوية اليدوي"
    }
  },
  personal: {
    autoVerification: {
      identificationText: "التحقق من الهوية"
    },
    persoanlKycStatus: {
      identificationText: "التحقق من الهوية"
    }
  }
};
